export interface PersonTypeBase {
  id: string;
  name: string;
  color: string;
}

export const personTypeBaseFields = `
  id
  name
  color
`;
